module.exports = __webpack_public_path__ + "img/357-d1c12f.png";